<button class="btn btn-primary btn-sm col-control-button" [style]="btn.cssStyle" (click)="onClick(btn)">
  @if (btn.icon) {
    <i class="col-control-button-icon" [class]="btn.icon"></i>
  }
  @if (btn.translate) {
    {{ btn.title | cxTranslate }}
  } @else {
    {{ btn.title || getData }}
  }
</button>
